<template>
    <v-flex>
    </v-flex>
</template>

<script>

  export default {
    name: "SocialRightSidebar",
    components: {
    },
};
</script>

<style lang="scss" scoped>
</style>
